module.exports = __webpack_public_path__ + "static/media/heth.5c4e4bd6.svg";